import TermsAndConditionsModal from "./TermsAndConditionsModal";
import { useReducer } from "react";
import "./Lightcast.scss";

import translate from "@/i18n/translate";
import { WmButton } from "@watermarkinsights/ripple-react";

const initialState = {
  openTermsAndConditionsModal: false
};

interface LightcastFooterState {
  openTermsAndConditionsModal: boolean;
}

interface LightcastFooterAction {
  data: boolean;
  type: string;
}

const defaultLightcastFooterAction = {
  data: false,
  type: ""
};

const reducer = (
  state: LightcastFooterState,
  action: LightcastFooterAction
) => {
  switch (action.type) {
    case "setTermsAndConditionsModalStatus":
      return {
        ...state,
        openTermsAndConditionsModal: action.data
      };
    default:
      return state;
  }
};

export default function LightcastFooter() {
  const [state, dispatch] = useReducer(reducer, initialState);

  const toggleTermsModal = (state: boolean) => {
    dispatch({
      ...defaultLightcastFooterAction,
      type: "setTermsAndConditionsModalStatus",
      data: state
    });
  };
  return (
    <div className="lightcast-branding-container">
      <div className="lightcast-branding">
        <span className="powered-by">
          {translate("app.lightcast.poweredBy")}
        </span>
        <img
          className="lightcast-logo"
          src="/../images/lighcast_logo.svg"
          alt="lightcast-logo"
        />
      </div>
      <WmButton buttonType="textonly" onClick={() => toggleTermsModal(true)}>
        <span className="terms-and-conditions">
          {translate("app.lightcast.viewTermsAndConditions")}
        </span>
      </WmButton>
      {state.openTermsAndConditionsModal && (
        <TermsAndConditionsModal onClose={() => toggleTermsModal(false)} />
      )}
    </div>
  );
}
